import { Link } from "react-router-dom";
import { usePublicSiteContent } from "../../../hooks/useSiteContent";
import { whatsappUrl } from "../../../lib/siteContentStore";

const fallbackHeroImage =
  "https://storage.readdy-site.link/project_files/617e2d57-bc82-454a-909d-4c3baccc9515/5210b6d6-20ed-4d9a-a316-2414274aa6c0_ChatGPT-Image-31-Mar-2026-00_04_35.png?v=5d7c553c8368b2c97240597ae7d07f85";

const sharePackages = [
  { title: "1. Hisse", type: "Dana", kg: "30–35 kg", price: "₺35.000" },
  { title: "2. Hisse", type: "Dana", kg: "40–45 kg", price: "₺41.000" },
  { title: "3. Hisse", type: "Dana", kg: "50–55 kg", price: "₺47.500" },
  { title: "4. Hisse", type: "Dana", kg: "60–65 kg", price: "₺54.000" },
  { title: "Düve", type: "Düve", kg: "35–40 kg", price: "₺33.000" },
];

export default function HeroSection() {
  const content = usePublicSiteContent();
  const heroImage = content.hero.imageUrl || fallbackHeroImage;

  return (
    <section className="relative overflow-hidden bg-farm-cream">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_8%,rgba(184,134,90,0.14),transparent_34%),radial-gradient(circle_at_12%_38%,rgba(139,175,119,0.08),transparent_28%),linear-gradient(180deg,#FFFEF8_0%,#FAF7F0_100%)]" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 pt-8 md:pt-11 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-[0.92fr_1.08fr] gap-7 lg:gap-10 items-center">
          <div className="z-10">
            <div className="inline-flex items-center gap-2 rounded-full border border-farm-earth/20 bg-farm-warm/90 px-4 py-2 text-farm-brown shadow-sm">
              <i className="ri-shield-check-line text-farm-earth text-base" />
              <span className="font-body text-xs md:text-sm font-bold tracking-[0.16em]">
                GÜVENİLİR • HELAL • HİJYENİK
              </span>
            </div>

            <h1 className="mt-5 font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-farm-brown leading-[1.03] tracking-tight">
              Evren Çiftliği
            </h1>
            <p className="mt-3 font-heading text-xl md:text-2xl font-semibold text-farm-green">
              Kurbanlık • Adaklık
            </p>
            <p className="mt-4 max-w-xl font-body text-sm md:text-base text-farm-muted leading-relaxed">
              Uzman ekip, hijyenik kesim ve zamanında teslimat ile sevdiklerinize güvenle hizmet sunuyoruz.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/giris"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-farm-brown px-6 py-3.5 text-white font-body text-sm md:text-base font-bold hover:bg-farm-earth transition-colors shadow-sm"
              >
                <i className="ri-user-line text-lg" />
                Müşteri Girişi
              </Link>
              <a
                href={whatsappUrl(content)}
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-farm-green px-6 py-3.5 text-white font-body text-sm md:text-base font-bold hover:bg-farm-green/90 transition-colors shadow-sm"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp ile Kayıt Ol
              </a>
            </div>

            <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <a
                href={whatsappUrl(content)}
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center gap-2 font-body text-lg md:text-xl font-extrabold text-farm-brown"
              >
                <i className="ri-whatsapp-line text-farm-green text-2xl" />
                {content.contactPhone}
              </a>
              <span className="font-body text-sm text-farm-muted">
                Kayıt işlemleri WhatsApp üzerinden yapılmaktadır.
              </span>
            </div>
          </div>

          <div className="relative min-h-[300px] md:min-h-[380px] lg:min-h-[430px] rounded-[28px] overflow-hidden border border-farm-border bg-farm-earth-pale shadow-[0_18px_44px_rgba(61,43,31,0.10)]">
            <img
              src={heroImage}
              alt="Evren Çiftliği büyükbaş ve kuzu"
              className="absolute inset-0 h-full w-full object-cover object-center"
              onError={(event) => {
                event.currentTarget.src = fallbackHeroImage;
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-farm-cream/18 via-transparent to-transparent" />
            <div className="absolute right-4 bottom-4 max-w-xs rounded-2xl border border-white/70 bg-farm-warm/85 px-4 py-3 backdrop-blur-sm shadow-sm">
              <p className="font-heading text-lg font-bold text-farm-brown">Avrupa Bölgesi</p>
              <p className="font-body text-xs text-farm-muted">İsteğe göre bayramın 2. günü kapı teslimi.</p>
            </div>
          </div>
        </div>

        <div id="hisseli-satis" className="mt-10 rounded-[28px] border border-farm-earth/20 bg-farm-warm/95 p-4 md:p-6 shadow-[0_14px_42px_rgba(61,43,31,0.07)]">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5">
            <div>
              <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">
                HİSSELİ SATIŞ PAKETLERİ
              </span>
              <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-farm-brown">
                Paketler ve Fiyatlar
              </h2>
            </div>
            <p className="max-w-md font-body text-sm text-farm-muted leading-relaxed">
              Broşürdeki paketler web sitesinde sade, okunabilir ve güven veren kartlar halinde sunuldu.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3.5">
            {sharePackages.map((item, index) => (
              <div
                key={item.title}
                className="relative rounded-[20px] border border-farm-earth/20 bg-farm-cream p-4 text-center shadow-sm hover:-translate-y-0.5 hover:shadow-md transition-all overflow-hidden"
              >
                <div className="absolute left-0 top-0 h-1.5 w-full bg-gradient-to-r from-farm-earth via-farm-gold to-farm-green" />
                <div className="mx-auto mb-2.5 flex h-11 w-11 items-center justify-center rounded-full bg-farm-earth-light text-farm-brown">
                  <i className={`${index === 4 ? "ri-leaf-line" : "ri-cow-line"} text-xl`} />
                </div>
                <h3 className="font-heading text-xl font-bold text-farm-brown">{item.title}</h3>
                <p className="font-body text-xs font-semibold text-farm-muted">{item.type}</p>
                <div className="mx-auto mt-2.5 inline-flex rounded-full bg-farm-earth-pale px-3 py-1 text-xs font-bold text-farm-brown">
                  {item.kg}
                </div>
                <p className="mt-3 font-heading text-2xl font-bold text-farm-brown">{item.price}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
